import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

export default function ConfirmDialog({
    open, setOpen
}) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{
                sx: {
                  backgroundColor: '#f8f6f6',
                  color: '#003a66',
                },
              }}
      >
        <DialogTitle sx={{color: '#003a66'}}>
          Thank you
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{color: '#757575'}}>
              We have received your submission and will be in touch soon.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button  onClick={() => setOpen(false)} autoFocus sx={{color: '#003a66'}}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    )
}
